'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var axios = require('axios');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  text-decoration: none;\n  line-height: 25px;\n  color: #000000;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-mobile-navigation__tpS-6 {\n  color: #4A4A4A;\n  flex-wrap: wrap;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-mobile-navigation__tpS-6 span.CmrPuntosMenuMobile_category-premium__7G3rs {\n  color: #808080;\n  font-weight: bold;\n}\n@media screen and (max-width: 428px) {\n  .CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-mobile-navigation__tpS-6 span.CmrPuntosMenuMobile_category-premium__7G3rs {\n    margin-left: 0;\n  }\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-mobile-navigation__tpS-6 span.CmrPuntosMenuMobile_category-fan__OIf02 {\n  color: #808080;\n  font-weight: bold;\n}\n@media screen and (max-width: 379px) {\n  .CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-mobile-navigation__tpS-6 span.CmrPuntosMenuMobile_category-fan__OIf02 {\n    margin-left: 0;\n  }\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-mobile-navigation__tpS-6 span.CmrPuntosMenuMobile_category-elite__fECbN {\n  color: #808080;\n  font-weight: bold;\n}\n@media screen and (max-width: 387px) {\n  .CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-mobile-navigation__tpS-6 span.CmrPuntosMenuMobile_category-elite__fECbN {\n    margin-left: 0;\n  }\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-mobile-navigation__tpS-6 .CmrPuntosMenuMobile_cmr-user-category-name__hwrYF {\n  margin-left: 0;\n  font-weight: 400;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-menu-mobile-rebrand__cl5hJ {\n  justify-content: flex-start;\n  align-items: center;\n  color: #495867;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16.8px;\n  margin-left: 1px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-menu-mobile-rebrand__cl5hJ img {\n  margin-left: 4px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-menu-mobile-rebrand__cl5hJ .CmrPuntosMenuMobile_cmrpuntos-menu-category-icon__BTT7U {\n  display: inline-flex;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-menu-mobile-rebrand__cl5hJ .CmrPuntosMenuMobile_cmr-puntos-available__vgHgS {\n  font-weight: bold;\n  margin-left: 0px !important;\n  font-size: 16px;\n  color: #333333;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-menu-mobile-rebrand__cl5hJ span.CmrPuntosMenuMobile_cmrpuntos-menu-vertical-line__gPdDD {\n  margin: 0px 4px 0 4px !important;\n  border-left: 2px solid #495867 !important;\n  height: 16px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-menu-mobile-rebrand__cl5hJ .CmrPuntosMenuMobile_cmr-user-category-name__hwrYF {\n  font-weight: 700;\n  margin-left: 4px !important;\n  font-size: 16px;\n  line-height: 14px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-menu-mobile-rebrand__cl5hJ .CmrPuntosMenuMobile_tienes-text__4hn-v {\n  font-size: 16px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM.CmrPuntosMenuMobile_cmr-puntos-menu-mobile-rebrand__cl5hJ .CmrPuntosMenuMobile_logged-in-tienes-text__sx93C {\n  margin-right: 4px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_cmrpuntos-menu-logged-in-user__1Cc44 {\n  display: flex;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_cmrpuntos-menu-category-icon__BTT7U img {\n  height: 17px;\n  width: 17px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_cmr-user-category-name__hwrYF {\n  font-size: 14px;\n  margin-left: 3px;\n  line-height: 17px;\n  text-transform: capitalize;\n  font-weight: bold;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_category-fan__OIf02 {\n  color: #EB0045;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_category-premium__7G3rs {\n  color: #808080;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_category-elite__fECbN {\n  color: #000000;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_cmrpuntos-menu-vertical-line__gPdDD {\n  width: 0px;\n  height: 15px;\n  border-left: 1px solid #5C6166;\n  margin-left: 6px;\n  margin-right: 7px;\n  margin-top: 2px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_cmr-puntos-available__vgHgS {\n  font-size: 15px;\n  line-height: 18px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_cmr-puntos-icon__2TT-w {\n  margin-left: 4px;\n  line-height: 21px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_tienes-text__4hn-v {\n  font-size: 15px;\n  line-height: 18px;\n  margin-right: 5px;\n  text-transform: capitalize;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_cmr_points__0S4zq {\n  margin: 0px 0px 0px 4px;\n  display: flex;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_has_cmr_title__OaVy8 {\n  display: inline-block;\n  margin-right: 4px;\n  font-size: 16px;\n}\n.CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM .CmrPuntosMenuMobile_user-action-icon-container__1gC1r {\n  display: inline-flex;\n  position: absolute;\n  right: 0;\n  top: 9px;\n  height: 65%;\n  width: 3.4375rem;\n  align-content: center;\n  justify-content: center;\n}\n\na:active {\n  color: #000000;\n}";
var styles$1 = {"cmr-puntos-menu-mobile":"CmrPuntosMenuMobile_cmr-puntos-menu-mobile__5AjsM","cmr-puntos-mobile-navigation":"CmrPuntosMenuMobile_cmr-puntos-mobile-navigation__tpS-6","category-premium":"CmrPuntosMenuMobile_category-premium__7G3rs","category-fan":"CmrPuntosMenuMobile_category-fan__OIf02","category-elite":"CmrPuntosMenuMobile_category-elite__fECbN","cmr-user-category-name":"CmrPuntosMenuMobile_cmr-user-category-name__hwrYF","cmr-puntos-menu-mobile-rebrand":"CmrPuntosMenuMobile_cmr-puntos-menu-mobile-rebrand__cl5hJ","cmrpuntos-menu-category-icon":"CmrPuntosMenuMobile_cmrpuntos-menu-category-icon__BTT7U","cmr-puntos-available":"CmrPuntosMenuMobile_cmr-puntos-available__vgHgS","cmrpuntos-menu-vertical-line":"CmrPuntosMenuMobile_cmrpuntos-menu-vertical-line__gPdDD","tienes-text":"CmrPuntosMenuMobile_tienes-text__4hn-v","logged-in-tienes-text":"CmrPuntosMenuMobile_logged-in-tienes-text__sx93C","cmrpuntos-menu-logged-in-user":"CmrPuntosMenuMobile_cmrpuntos-menu-logged-in-user__1Cc44","cmr-puntos-icon":"CmrPuntosMenuMobile_cmr-puntos-icon__2TT-w","cmr_points":"CmrPuntosMenuMobile_cmr_points__0S4zq","has_cmr_title":"CmrPuntosMenuMobile_has_cmr_title__OaVy8","user-action-icon-container":"CmrPuntosMenuMobile_user-action-icon-container__1gC1r"};
styleInject(css_248z$1);

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var constants = {
  tenants: {
    'falabella-cl': {
      CMR_POINTS_AND_CATEGORY_ENDPOINT_CATALYST: '/s/fif/v1/loyalty/get-points-and-category',
      CMR_POINTS_HEADER: {
        'x-country': 'CL',
        'x-channel': 'Web',
        'x-ecomm-name': 'falabella-cl',
        'x-channel-id': 'WEB'
      },
      CMR_POINTS_HOST: '',
      CMR_POINTS_STATUS_CODES: {
        SUCCESS: 200
      },
      COOKIE_KEYS: {
        CMR_POINTS: 'CMR_POINTS',
        USER_DETAILS_COOKIE: 'USER_DETAILS_COOKIE',
        USER_ID: 'USER_ID',
        SESSION_ID: 'sid'
      }
    },
    'falabella-co': {
      CMR_POINTS_HEADER: {
        'x-country': 'CO',
        'x-channel': 'Web',
        'x-ecomm-name': 'falabella-co',
        'x-channel-id': 'WEB'
      },
      CMR_POINTS_AND_CATEGORY_ENDPOINT_ATG: '/rest/model/atg/userprofiling/ProfileActor/get-cmr-points-and-category',
      CMR_POINTS_HOST: '',
      CMR_POINTS_STATUS_CODES: {
        SUCCESS: 200
      },
      COOKIE_KEYS: {
        CMR_POINTS: 'CMR_POINTS',
        USER_DETAILS_COOKIE: 'USER_DETAILS_COOKIE',
        USER_ID: 'USER_ID',
        SESSION_CONFIRMATION_NUMBER: 'scn',
        SESSION_ID: 'sid'
      }
    },
    'falabella-pe': {
      CMR_POINTS_AND_CATEGORY_ENDPOINT_ATG: '/rest/model/atg/userprofiling/ProfileActor/get-cmr-points-and-category',
      CMR_POINTS_AND_CATEGORY_ENDPOINT_CATALYST: '/s/fif/v1/loyalty/get-points-and-category',
      CMR_POINTS_HEADER: {
        'x-country': 'PE',
        'x-channel': 'Web',
        'x-ecomm-name': 'falabella-pe',
        'x-channel-id': 'WEB'
      },
      CMR_POINTS_HOST: '',
      CMR_POINTS_STATUS_CODES: {
        SUCCESS: 200
      },
      COOKIE_KEYS: {
        CMR_POINTS: 'CMR_POINTS',
        USER_DETAILS_COOKIE: 'USER_DETAILS_COOKIE',
        USER_ID: 'USER_ID',
        SESSION_CONFIRMATION_NUMBER: 'scn',
        SESSION_ID: 'sid'
      }
    },
    'falabella-ar': {
      CMR_POINTS_AND_CATEGORY_ENDPOINT_ATG: '/rest/model/atg/userprofiling/ProfileActor/get-cmr-points-and-category',
      CMR_POINTS_HOST: '',
      CMR_POINTS_STATUS_CODES: {
        SUCCESS: 200
      },
      COOKIE_KEYS: {
        CMR_POINTS: 'CMR_POINTS',
        USER_DETAILS_COOKIE: 'USER_DETAILS_COOKIE',
        USER_ID: 'USER_ID',
        SESSION_CONFIRMATION_NUMBER: 'scn'
      }
    }
  }
};
var constants$1 = constants;

var makeCall = function () {
  var _ref = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(reqObj) {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return axios__default["default"](reqObj);
        case 2:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function makeCall(_x) {
    return _ref.apply(this, arguments);
  };
}();
var makeGetCall = function () {
  var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(options) {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return makeCall({
            url: options.url,
            headers: options.headers,
            params: options.params,
            signal: options.abortController.signal
          });
        case 2:
          response = _context2.sent;
          return _context2.abrupt("return", response);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function makeGetCall(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var makePostCall = function () {
  var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3(url, headers, data) {
    var response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          response = makeCall({
            headers: headers,
            url: url,
            data: data,
            method: 'POST'
          });
          return _context3.abrupt("return", response);
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function makePostCall(_x3, _x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

var DEFAULT_COOKIE_DOMAIN = '.falabella.com';
var isSodimacSite = function isSodimacSite() {
  return /sodimac\.(cl|com\.pe)/.test(window.location.origin);
};
var isTottusSite = function isTottusSite() {
  return /tottus\.(cl|com\.pe)/.test(window.location.origin);
};
var getCookieProp = function getCookieProp(cookieName) {
  if (!global.document || typeof global.document.cookie !== 'string') {
    return null;
  }
  var result = global.document.cookie.match("(^|;)\\s*".concat(cookieName, "\\s*=\\s*([^;]+)"));
  return result ? decodeURIComponent(result.pop()) : null;
};
var getHost = function getHost(regionCode) {
  var sodimacHosts = {
    cl: '.sodimac.cl',
    pe: '.sodimac.com.pe'
  };
  var tottusHosts = {
    cl: '.tottus.cl',
    pe: '.tottus.com.pe'
  };
  if (isSodimacSite()) {
    return sodimacHosts[regionCode];
  }
  if (isTottusSite()) {
    return tottusHosts[regionCode];
  }
  var domain = DEFAULT_COOKIE_DOMAIN;
  var region = '';
  if (regionCode === 'cl' || !regionCode) {
    region = '';
  } else {
    region = ".".concat(regionCode);
  }
  return "".concat(domain).concat(region);
};
var setCookie = function setCookie(_ref) {
  var _cookieValues;
  var cookieName = _ref.cookieName,
    cookieValue = _ref.cookieValue,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '/' : _ref$path,
    tenantId = _ref.tenantId;
  if (!global.document || typeof global.document.cookie !== 'string') {
    return false;
  }
  var expirationDate = new Date(Date.now() + 1200000);
  var expiration = expirationDate.toGMTString();
  var regionCode = tenantId ? tenantId.split('-')[1] : '';
  var domain = getHost(regionCode);
  var cookieValues = (_cookieValues = {}, _defineProperty(_cookieValues, cookieName, cookieValue ? encodeURIComponent(cookieValue) : cookieValue), _defineProperty(_cookieValues, "expires", expiration), _defineProperty(_cookieValues, "path", path), _defineProperty(_cookieValues, "domain", domain), _cookieValues);
  var cookie = Object.entries(cookieValues).reduce(function (acc, entry) {
    return [].concat(_toConsumableArray(acc), [entry.join('=')]);
  }, []).join('; ');
  global.document.cookie = cookie;
  return cookie;
};
var isCatalyst = function isCatalyst() {
  return getCookieProp('experience') === 'CATALYST';
};

var Base64Util = function () {
  function Base64Util() {
    _classCallCheck(this, Base64Util);
  }
  _createClass(Base64Util, null, [{
    key: "encodeObj",
    value: function encodeObj(obj) {
      return btoa(JSON.stringify(obj));
    }
  }, {
    key: "decodeObj",
    value: function decodeObj(str) {
      return JSON.parse(atob(str));
    }
  }]);
  return Base64Util;
}();
var Base64Util$1 = Base64Util;

var getFromCookie = function getFromCookie() {
  var cmrPointsCookieValue = getCookieProp('CMR_POINTS');
  if (cmrPointsCookieValue == null) {
    return null;
  }
  return Base64Util$1.decodeObj(cmrPointsCookieValue);
};
var getCmrPointsATG = function getCmrPointsATG(tenant) {
  var COOKIE_KEYS = tenant.COOKIE_KEYS,
    CMR_POINTS_AND_CATEGORY_ENDPOINT_ATG = tenant.CMR_POINTS_AND_CATEGORY_ENDPOINT_ATG;
  try {
    var sessionConfirmationNumber = getCookieProp(COOKIE_KEYS.SESSION_CONFIRMATION_NUMBER);
    var requestBody = {
      sessionConfirmationNumber: sessionConfirmationNumber
    };
    var headers = {};
    var response = makePostCall(CMR_POINTS_AND_CATEGORY_ENDPOINT_ATG, headers, requestBody);
    return response;
  } catch (error) {
    return {
      error: error
    };
  }
};
var getCmrPointsCatalyst = function () {
  var _ref = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(tenant, options) {
    var CMR_POINTS_HEADER, CMR_POINTS_AND_CATEGORY_ENDPOINT_CATALYST, COOKIE_KEYS, cmrPointsIncreaseURL, headers, sid, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          CMR_POINTS_HEADER = tenant.CMR_POINTS_HEADER, CMR_POINTS_AND_CATEGORY_ENDPOINT_CATALYST = tenant.CMR_POINTS_AND_CATEGORY_ENDPOINT_CATALYST, COOKIE_KEYS = tenant.COOKIE_KEYS;
          _context.prev = 1;
          cmrPointsIncreaseURL = "".concat(CMR_POINTS_AND_CATEGORY_ENDPOINT_CATALYST);
          headers = _objectSpread2({}, CMR_POINTS_HEADER);
          sid = getCookieProp(COOKIE_KEYS.SESSION_ID);
          if (sid) {
            headers.Authorization = sid;
          }
          _context.next = 8;
          return makeGetCall({
            url: cmrPointsIncreaseURL,
            headers: headers,
            abortController: options.abortController
          });
        case 8:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", {
            error: _context.t0
          });
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 12]]);
  }));
  return function getCmrPointsCatalyst(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getCmrPoints = function () {
  var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(tenantId, options) {
    var tenants, tenant;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          tenants = constants$1.tenants;
          tenant = tenants[tenantId];
          if (!(tenantId === 'falabella-cl')) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", getCmrPointsCatalyst(tenant, options));
        case 4:
          if (!(tenantId === 'falabella-pe')) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return", isCatalyst() ? getCmrPointsCatalyst(tenant, options) : getCmrPointsATG(tenant));
        case 6:
          return _context2.abrupt("return", getCmrPointsATG(tenant));
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getCmrPoints(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var cmrPointsService = {
  getCmrPoints: getCmrPoints,
  getFromCookie: getFromCookie
};
var cmrPointsService$1 = cmrPointsService;

var useCmrPoints$1 = function useCmrPoints(tenantId, isCmrPointsEnabled, isLoggedIn, cmrPoints) {
  var getCmrPoints = cmrPointsService$1.getCmrPoints;
  var tenants = constants$1.tenants;
  var _useState = React.useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    balancePoints = _useState2[0],
    setPoints = _useState2[1];
  var _useState3 = React.useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loggedIn = _useState4[0],
    setLoggedIn = _useState4[1];
  var _useState5 = React.useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    cmrCategory = _useState6[0],
    setCmrCategory = _useState6[1];
  var COOKIE_KEYS = tenants[tenantId].COOKIE_KEYS;
  var isValidCmrPointsArg = _typeof(cmrPoints) === 'object' && Object.keys(cmrPoints).length > 0;
  React.useEffect(function () {
    if (isValidCmrPointsArg) {
      return;
    }
    var abortController = new AbortController();
    function fetchPoints() {
      return _fetchPoints.apply(this, arguments);
    }
    function _fetchPoints() {
      _fetchPoints = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
        var response, _response$data, points, category;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getCmrPoints(tenantId, {
                abortController: abortController
              });
            case 3:
              response = _context.sent;
              if (response.data.status === 'SUCCESS') {
                _response$data = response.data, points = _response$data.points, category = _response$data.category;
                setPoints(points.balance);
                setCmrCategory(category);
                setCookie({
                  cookieName: 'CMR_POINTS',
                  cookieValue: Base64Util$1.encodeObj(response.data),
                  tenantId: tenantId
                });
              }
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setLoggedIn(false);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
      return _fetchPoints.apply(this, arguments);
    }
    function pointsFetchHandler() {
      return _pointsFetchHandler.apply(this, arguments);
    }
    function _pointsFetchHandler() {
      _pointsFetchHandler = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2() {
        var cmrPointsCookieValue, points, category;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              setLoggedIn(true);
              cmrPointsCookieValue = cmrPointsService$1.getFromCookie();
              if (!(cmrPointsCookieValue == null)) {
                _context2.next = 7;
                break;
              }
              _context2.next = 5;
              return fetchPoints();
            case 5:
              _context2.next = 10;
              break;
            case 7:
              points = cmrPointsCookieValue.points, category = cmrPointsCookieValue.category;
              setPoints(points.balance);
              setCmrCategory(category);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _pointsFetchHandler.apply(this, arguments);
    }
    function pointsFetchFail() {
      setPoints(-1);
      setCmrCategory(null);
    }
    function cleanUp() {
      abortController.abort();
    }
    function handlePointsFetching() {
      return _handlePointsFetching.apply(this, arguments);
    }
    function _handlePointsFetching() {
      _handlePointsFetching = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = tenantId;
              _context3.next = _context3.t0 === 'falabella-cl' ? 3 : _context3.t0 === 'falabella-pe' ? 10 : 17;
              break;
            case 3:
              if (!(getCookieProp(COOKIE_KEYS.USER_ID) != null && isCatalyst() && isCmrPointsEnabled && isLoggedIn)) {
                _context3.next = 8;
                break;
              }
              _context3.next = 6;
              return pointsFetchHandler();
            case 6:
              _context3.next = 9;
              break;
            case 8:
              pointsFetchFail();
            case 9:
              return _context3.abrupt("break", 24);
            case 10:
              if (!(isCmrPointsEnabled && isLoggedIn && (isCatalyst() && getCookieProp(COOKIE_KEYS.USER_ID) != null || getCookieProp(COOKIE_KEYS.SESSION_CONFIRMATION_NUMBER)))) {
                _context3.next = 15;
                break;
              }
              _context3.next = 13;
              return pointsFetchHandler();
            case 13:
              _context3.next = 16;
              break;
            case 15:
              pointsFetchFail();
            case 16:
              return _context3.abrupt("break", 24);
            case 17:
              if (!(isCmrPointsEnabled && getCookieProp(COOKIE_KEYS.SESSION_CONFIRMATION_NUMBER) && isLoggedIn)) {
                _context3.next = 22;
                break;
              }
              _context3.next = 20;
              return pointsFetchHandler();
            case 20:
              _context3.next = 23;
              break;
            case 22:
              pointsFetchFail();
            case 23:
              return _context3.abrupt("break", 24);
            case 24:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _handlePointsFetching.apply(this, arguments);
    }
    handlePointsFetching();
    return function () {
      cleanUp();
    };
  }, [isLoggedIn]);
  if (isValidCmrPointsArg) {
    return cmrPoints;
  }
  return {
    balancePoints: balancePoints,
    loggedIn: loggedIn,
    cmrCategory: cmrCategory
  };
};
var useCmrPoints$2 = useCmrPoints$1;

var hooks = {
  useCmrPoints: useCmrPoints$2
};
var hooks$1 = hooks;

var iconMaker$3 = function iconMaker(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '15px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '15px' : _ref$height;
  return React__default["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default["default"].createElement("path", {
    d: "M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z",
    fill: "#EB0045"
  }), React__default["default"].createElement("path", {
    d: "M10.4224 5.71731C10.9537 5.71731 11.4596 5.97028 11.7885 6.40034C12.1174 6.8304 12.2438 7.38695 12.1174 7.8929C11.9909 8.44945 11.662 8.9554 11.0802 9.58784C10.3971 10.2962 9.5876 10.9792 8.52509 11.6875C7.46259 10.9792 6.65307 10.2962 5.97003 9.58784C5.38819 8.9807 5.08462 8.47475 4.93283 7.8929C4.80634 7.36165 4.93283 6.8304 5.2617 6.40034C5.59057 5.97028 6.09652 5.71731 6.62777 5.71731C6.75426 5.71731 6.85545 5.71731 6.98194 5.74261C7.3614 5.8185 7.69027 6.02088 8.04444 6.37505L8.52509 6.881L9.00575 6.37505C9.35992 6.02088 9.68879 5.8185 10.0683 5.74261C10.1694 5.74261 10.2959 5.71731 10.4224 5.71731ZM10.4224 5.05957C10.2706 5.05957 10.0935 5.08487 9.94176 5.11017C9.38521 5.21136 8.95515 5.51493 8.52509 5.94499C8.12033 5.51493 7.66498 5.23665 7.10843 5.11017C6.95664 5.08487 6.77956 5.05957 6.62777 5.05957C5.10992 5.05957 3.92093 6.50153 4.27509 8.06999C4.47747 8.87951 4.93283 9.48665 5.46408 10.0685C6.3242 10.9539 7.31081 11.7128 8.34801 12.3959C8.39861 12.4212 8.4492 12.4465 8.52509 12.4465C8.57569 12.4465 8.65158 12.4212 8.70218 12.3959C9.73938 11.7128 10.726 10.9792 11.5861 10.0685C12.1427 9.48665 12.598 8.87951 12.7751 8.06999C13.1293 6.50153 11.915 5.05957 10.4224 5.05957Z",
    fill: "white"
  }));
};
var CategoryFanIcon = function CategoryFanIcon(_ref2) {
  var isRebrandingEnabled = _ref2.isRebrandingEnabled;
  if (isRebrandingEnabled) return iconMaker$3({
    width: '16px',
    height: '16px'
  });else return iconMaker$3({
    width: '15px',
    height: '15px'
  });
};
var CategoryFanIcon$1 = CategoryFanIcon;

var iconMaker$2 = function iconMaker(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '15px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '15px' : _ref$height;
  return React__default["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default["default"].createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#808080"
  }), React__default["default"].createElement("path", {
    d: "M12.0003 7.41493L13.1108 9.81493L13.3257 10.2806L13.863 10.3522L16.5138 10.6746L14.5794 12.4657L14.1854 12.8239L14.2929 13.3254L14.7944 15.9403L12.466 14.6508L12.0003 14.4L11.5347 14.6508L9.2063 15.9403L9.70779 13.3254L9.81526 12.8239L9.42123 12.4657L7.4869 10.6746L10.1376 10.3522L10.675 10.2806L10.8899 9.81493L12.0003 7.41493ZM12.0003 5.55225C11.8929 5.55225 11.8212 5.58807 11.7496 5.69553L10.0302 9.4209L5.9466 9.9224C5.73167 9.95822 5.62421 10.2448 5.80332 10.3881L8.81227 13.1821L8.02421 17.194C7.98839 17.3731 8.13168 17.5164 8.27496 17.5164C8.31078 17.5164 8.3466 17.5164 8.41824 17.4806L12.0003 15.4746L15.5824 17.4806C15.6182 17.5164 15.6541 17.5164 15.7257 17.5164C15.869 17.5164 16.0123 17.3731 15.9765 17.194L15.1884 13.1821L18.1973 10.3881C18.3765 10.2448 18.269 9.95822 18.0541 9.9224L13.9705 9.4209L12.2511 5.69553C12.2153 5.58807 12.1078 5.55225 12.0003 5.55225Z",
    fill: "white"
  }));
};
var CategoryPremiumIcon = function CategoryPremiumIcon(_ref2) {
  var isRebrandingEnabled = _ref2.isRebrandingEnabled;
  if (isRebrandingEnabled) return iconMaker$2({
    width: '16px',
    height: '16px'
  });else return iconMaker$2({
    width: '15px',
    height: '15px'
  });
};
var CategoryPremiumIcon$1 = CategoryPremiumIcon;

var iconMaker$1 = function iconMaker(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '15px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '15px' : _ref$height;
  return React__default["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default["default"].createElement("path", {
    d: "M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z",
    fill: "black"
  }), React__default["default"].createElement("path", {
    d: "M12.1384 4.09405C12.1071 4.03135 12.013 4 11.9503 4H8.72132H5.52365C5.46095 4 5.39825 4.03135 5.33555 4.09405L3.04702 6.94687C2.98433 7.04092 2.98433 7.16632 3.04702 7.22902L8.53322 14.126C8.62727 14.2513 8.81536 14.2513 8.90941 14.126L14.3956 7.22902C14.4583 7.13497 14.4583 7.00957 14.3956 6.94687L12.1384 4.09405ZM4.08156 6.94687L5.21015 5.50479C5.33555 5.34804 5.555 5.41074 5.6177 5.56748L7.18518 10.4267C7.27923 10.6775 6.93438 10.8342 6.77764 10.6461L4.05021 7.22902C4.01886 7.16632 4.01886 7.04092 4.08156 6.94687ZM6.30739 5.09724C6.24469 4.94049 6.37009 4.78374 6.52684 4.78374H8.72132H10.9158C11.0725 4.78374 11.1979 4.94049 11.1352 5.09724L8.94076 11.8688C8.87806 12.0882 8.56457 12.0882 8.50187 11.8688L6.30739 5.09724ZM12.2325 5.50479L13.3611 6.94687C13.4238 7.04092 13.4238 7.16632 13.3611 7.22902L10.6336 10.6461C10.4769 10.8342 10.1634 10.6775 10.2261 10.4267L11.7936 5.56748C11.8876 5.41074 12.1384 5.37939 12.2325 5.50479Z",
    fill: "white"
  }));
};
var CategoryEliteIcon = function CategoryEliteIcon(_ref2) {
  var isRebrandingEnabled = _ref2.isRebrandingEnabled;
  if (isRebrandingEnabled) return iconMaker$1({
    width: '16px',
    height: '16px'
  });else return iconMaker$1({
    width: '15px',
    height: '15px'
  });
};
var CategoryEliteIcon$1 = CategoryEliteIcon;

var getCategoryStyle = function getCategoryStyle(categoryName, isRebrandingEnabled) {
  var categoryStyle = {
    categoryClassName: '',
    categoryIcon: '',
    verticalLineColor: ''
  };
  switch (categoryName) {
    case 'Fan':
      categoryStyle.categoryClassName = 'category-fan';
      categoryStyle.categoryIcon = React__default["default"].createElement(CategoryFanIcon$1, {
        isRebrandingEnabled: isRebrandingEnabled
      });
      categoryStyle.verticalLineColor = 'category-fan-vertical-line';
      break;
    case 'Premium':
      categoryStyle.categoryClassName = 'category-premium';
      categoryStyle.categoryIcon = React__default["default"].createElement(CategoryPremiumIcon$1, {
        isRebrandingEnabled: isRebrandingEnabled
      });
      categoryStyle.verticalLineColor = 'category-premium-vertical-line';
      break;
    case 'Elite':
      categoryStyle.categoryClassName = 'category-elite';
      categoryStyle.categoryIcon = React__default["default"].createElement(CategoryEliteIcon$1, {
        isRebrandingEnabled: isRebrandingEnabled
      });
      categoryStyle.verticalLineColor = 'category-elite-vertical-line';
      break;
    default:
      console.log('do nothing');
  }
  return categoryStyle;
};
var formatPonits = function formatPonits(points, tenantId) {
  if (tenantId === 'falabella-pe') {
    return points.toLocaleString('en');
  }
  return points.toLocaleString('en').replace(/,/g, '.');
};

var iconMaker = function iconMaker(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '29px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '14px' : _ref$height;
  return React__default["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 29 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default["default"].createElement("path", {
    d: "M18.111 7.58053C18.3405 7.58053 18.4359 7.37485 18.4246 7.25242V6.66639V6.32522L18.4262 6.32032H17.0605V4.81851L17.0475 4.82178L17.0605 4.81198H15.8854C15.6107 4.80872 15.4927 5.05684 15.5089 5.20702V5.90732V6.32032H14.5165V7.57237H15.5089V9.40718V9.98342C15.5089 11.0902 16.3041 11.5179 17.3385 11.5179C17.7037 11.5179 18.0868 11.4869 18.4262 11.3612V10.0552C18.292 10.1809 17.9623 10.2022 17.7959 10.2022C17.1833 10.2022 17.0799 9.87242 17.0637 9.40718C17.0637 9.36148 17.0605 9.31251 17.0605 9.2668V7.58053H18.111Z",
    fill: "#333333"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57262 6.97581C1.81344 6.60199 2.42115 6.1694 3.13392 6.1694C4.6435 6.1694 5.64073 7.26801 5.64073 8.82368C5.64073 9.02284 5.62133 9.21383 5.58739 9.40808C5.38051 10.585 4.56107 11.558 3.31655 11.558C2.66359 11.558 1.92981 11.38 1.57585 10.8805H1.55322V13.285C1.50797 13.5952 1.34634 13.9429 0.864696 14H0V6.29836H1.5516V6.97581H1.57262ZM1.6464 9.40671C1.81934 9.87031 2.22664 10.1625 2.81172 10.1625C3.39196 10.1625 3.80087 9.87031 3.97219 9.40671C4.03361 9.24673 4.06593 9.0639 4.06593 8.86475C4.06593 8.09263 3.59399 7.56373 2.81172 7.56373C2.02137 7.56373 1.55104 8.09263 1.55104 8.86475C1.55104 9.0639 1.58498 9.2451 1.6464 9.40671Z",
    fill: "#333333"
  }), React__default["default"].createElement("path", {
    d: "M12.4066 6.22049C11.7681 6.22049 11.3107 6.51759 11.0586 6.8457L10.9762 6.9665C10.9762 6.9665 10.981 6.83427 10.9762 6.78856V6.7853L10.9746 6.76408V6.74286L10.9729 6.73959L10.9697 6.70858L10.96 6.67593L10.9536 6.64981L10.9422 6.6139L10.9277 6.58451L10.9115 6.55023L10.8921 6.51922L10.8647 6.48494L10.8388 6.46045L10.8049 6.43107L10.7758 6.40985L10.7257 6.38699L10.6933 6.37393L10.5931 6.34945H9.42457V8.87477C9.42457 9.06086 9.41164 9.24369 9.38255 9.4102C9.30012 9.83952 9.07385 10.1693 8.49361 10.1693C7.95217 10.1693 7.77438 9.8183 7.71619 9.4102C7.69033 9.21921 7.68387 9.02005 7.68387 8.83233V6.34782H6.56704C6.42965 6.35924 6.16782 6.42454 6.13226 6.74775V9.14575C6.13226 9.23716 6.14034 9.32041 6.14034 9.40856C6.18237 10.6329 6.52825 11.5486 7.99742 11.5486C8.63261 11.5486 9.09324 11.2499 9.34699 10.9218L9.40033 10.8434L9.48276 10.6965V10.9104V10.9479V10.9561L9.48599 11.0018V11.0099L9.48922 11.0214L9.50054 11.0752L9.50377 11.0899L9.51993 11.1405L9.52317 11.1487C9.57004 11.2744 9.67671 11.405 9.91107 11.4246H10.2295H10.9778V9.40856V8.89436C10.9778 8.2365 11.0974 7.6015 11.9088 7.6015C12.7072 7.6015 12.7169 8.3524 12.7169 8.93517V9.40856V11.4229H14.2717V9.40856V8.62501C14.2685 7.26196 13.9759 6.22049 12.4066 6.22049Z",
    fill: "#333333"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8488 8.87664C18.8488 7.25241 20.0949 6.20441 21.6562 6.20441C23.2143 6.20441 24.4636 7.25241 24.4652 8.87664C24.4652 9.06274 24.441 9.2374 24.4103 9.4088C24.1678 10.7245 23.0349 11.5489 21.6562 11.5489C20.2743 11.5489 19.1413 10.7245 18.8989 9.4088C18.8698 9.2374 18.8488 9.06274 18.8488 8.87664ZM20.4988 9.407C20.6686 9.8706 21.0791 10.1628 21.6577 10.1628C22.2363 10.1628 22.6468 9.8706 22.8166 9.407C22.8747 9.24866 22.9071 9.06909 22.9071 8.87484C22.9071 8.10924 22.4367 7.58524 21.6577 7.58524C20.8787 7.58524 20.4083 8.10924 20.4083 8.87484C20.4083 9.06909 20.4407 9.24866 20.4988 9.407Z",
    fill: "#333333"
  }), React__default["default"].createElement("path", {
    d: "M28.9385 9.40804C28.5571 8.02214 26.3816 8.489 26.3816 7.80176C26.3816 7.49977 26.6919 7.3855 26.9521 7.3855C27.3239 7.3855 27.6229 7.53078 27.8491 7.81156L28.8044 6.8615C28.3373 6.36199 27.6035 6.19711 26.9408 6.19711C25.8822 6.19711 24.8284 6.71622 24.8284 7.90787C24.8284 8.98362 25.6397 9.24643 26.3573 9.40804C26.9327 9.53537 27.4467 9.60393 27.4467 9.96142C27.4467 10.2357 27.0944 10.3271 26.7404 10.3271C26.2765 10.3271 25.9323 10.1312 25.6446 9.77533L24.7007 10.8282C25.1985 11.3408 25.9743 11.5204 26.6774 11.5204C27.757 11.5204 28.9999 11.1433 28.9999 9.85042C29.0015 9.68065 28.9773 9.54027 28.9385 9.40804Z",
    fill: "#333333"
  }), React__default["default"].createElement("path", {
    d: "M2.39465 4.22791C2.62416 4.22791 2.82781 4.20016 3.0056 4.14466C3.18338 4.08916 3.34824 4.03202 3.50179 3.97489C3.56805 3.94551 3.61654 3.94061 3.64563 3.95693C3.67473 3.97326 3.70059 4.00917 3.72483 4.06141L3.96888 4.58378C4.00283 4.6507 4.01414 4.70294 4.00444 4.73559C3.99474 4.76987 3.96888 4.79925 3.92525 4.82211C3.66664 4.98208 3.39511 5.08982 3.11065 5.14532C2.82619 5.20082 2.54496 5.22857 2.26697 5.22857C1.87422 5.22857 1.5348 5.16981 1.25034 5.05064C0.965883 4.93148 0.72991 4.76171 0.545657 4.5397C0.361404 4.31769 0.225638 4.04508 0.136744 3.7235C0.0478503 3.40192 0.00421143 3.03953 0.00421143 2.63959C0.00421143 2.24292 0.0607804 1.88216 0.172302 1.55894C0.28544 1.23573 0.442216 0.956586 0.642632 0.724785C0.843048 0.492984 1.0871 0.313421 1.37156 0.187726C1.65602 0.0620312 1.97119 0 2.31546 0C2.55951 0 2.79872 0.0212212 3.03307 0.0620312C3.26743 0.102841 3.49694 0.186093 3.72321 0.311788C3.77655 0.341171 3.80726 0.370555 3.81696 0.398305C3.82665 0.427688 3.81534 0.48319 3.7814 0.56481L3.55836 1.06596C3.53411 1.13452 3.50987 1.17533 3.48239 1.19002C3.45653 1.20471 3.40966 1.19981 3.34178 1.17533C3.16884 1.11166 3.00883 1.06596 2.86013 1.03331C2.71144 1.00229 2.54658 0.985969 2.36394 0.985969C2.16676 0.985969 1.99382 1.02841 1.84351 1.1133C1.6932 1.19818 1.56551 1.31408 1.46207 1.461C1.35863 1.60791 1.28105 1.78258 1.22933 1.98336C1.176 2.18415 1.15014 2.40289 1.15014 2.63959C1.15014 2.87629 1.17115 3.09176 1.21479 3.28602C1.25842 3.48027 1.32792 3.64678 1.42328 3.78717C1.51864 3.92755 1.64633 4.03692 1.8031 4.11365C1.96311 4.19037 2.1603 4.22791 2.39465 4.22791Z",
    fill: "#333333"
  }), React__default["default"].createElement("path", {
    d: "M8.54352 2.225H8.49989L8.20573 2.89918L7.60933 4.23448C7.55599 4.36018 7.50266 4.44506 7.4477 4.48914C7.39275 4.53321 7.31032 4.55443 7.20042 4.55443H6.80605C6.68645 4.55443 6.60402 4.53321 6.55876 4.48914C6.51351 4.44506 6.46179 4.36181 6.4036 4.23448L5.95752 3.29096L5.51143 2.31152H5.46779V5.00334C5.46779 5.07027 5.45648 5.11271 5.43223 5.12741C5.40799 5.1421 5.36597 5.14863 5.30293 5.14863H4.57077C4.51743 5.14863 4.47703 5.1421 4.44794 5.12741C4.41884 5.11271 4.4043 5.0719 4.4043 5.00334V0.569749C4.4043 0.385288 4.43824 0.254696 4.50774 0.177973C4.57724 0.10125 4.69522 0.0620728 4.86331 0.0620728H5.28031C5.41446 0.0620728 5.51305 0.0881911 5.5777 0.138795C5.64235 0.1894 5.70377 0.277549 5.76033 0.403244L6.5426 2.1744L6.98869 3.20444H7.01778L7.50589 2.07319L8.23805 0.419568C8.29624 0.288976 8.35927 0.197562 8.42877 0.143693C8.49827 0.0898235 8.60979 0.0637052 8.76334 0.0637052H9.11568C9.26922 0.0637052 9.38398 0.0963531 9.45994 0.161649C9.53591 0.226945 9.5747 0.351007 9.5747 0.535468V5.00498C9.5747 5.0719 9.56338 5.11435 9.53914 5.12904C9.51489 5.14373 9.47287 5.15026 9.40984 5.15026H8.69869C8.64535 5.15026 8.60656 5.14373 8.5807 5.12904C8.55484 5.11435 8.54191 5.07354 8.54191 5.00498V2.225H8.54352Z",
    fill: "#333333"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.809 3.07888C13.7427 2.94503 13.628 2.84382 13.4647 2.77036L13.455 2.73771C13.6716 2.62181 13.8365 2.45367 13.9512 2.23657C14.066 2.01782 14.1242 1.78602 14.1242 1.53953C14.1242 1.08899 13.9819 0.731494 13.6975 0.465413C13.413 0.200965 13.009 0.0671082 12.4869 0.0671082H10.7268C10.5555 0.0671082 10.4407 0.104653 10.3825 0.179744C10.326 0.254834 10.2969 0.364205 10.2969 0.509488V5.00022C10.2969 5.05735 10.3098 5.09816 10.3357 5.11938C10.3615 5.1406 10.4035 5.15203 10.4617 5.15203H11.2311C11.3022 5.15203 11.3474 5.14223 11.3668 5.12591C11.3862 5.10795 11.3959 5.06714 11.3959 4.99858V3.09031H12.0925C12.3075 3.09031 12.4756 3.13602 12.5984 3.22743C12.7196 3.31885 12.8134 3.48372 12.8748 3.72042L13.1916 5.00511C13.2158 5.07857 13.2562 5.12101 13.3144 5.13244C13.371 5.14387 13.4259 5.1504 13.4793 5.1504H14.2341C14.2906 5.1504 14.3262 5.12918 14.3375 5.08837C14.3488 5.04756 14.3504 5.01328 14.3407 4.98389L13.9739 3.53269C13.9318 3.36292 13.8753 3.21274 13.809 3.07888ZM12.981 1.41391C12.9988 1.48247 13.0069 1.54776 13.0069 1.60979C13.0069 1.78283 12.9503 1.92485 12.842 2.03585C12.7321 2.14522 12.5705 2.19909 12.3604 2.19909H11.4052V1.03845H12.3814C12.5058 1.03845 12.6077 1.05641 12.6901 1.09232C12.7709 1.12824 12.8355 1.17394 12.884 1.22944C12.9325 1.28495 12.9648 1.34698 12.981 1.41391Z",
    fill: "#333333"
  }));
};
var CmrPointsIcon = function CmrPointsIcon(_ref2) {
  var isRebrandingEnabled = _ref2.isRebrandingEnabled;
  if (isRebrandingEnabled) return iconMaker({
    width: '29px',
    height: '14px'
  });else return iconMaker({
    width: '15px',
    height: '15px'
  });
};
var CmrPointsIcon$1 = CmrPointsIcon;

var CMR_PUNTOS_ALT_LOGO_TEXT = 'cmr puntos image';
var CMR_MENU_LOGGED_IN_USER = 'cmrpuntos-menu-logged-in-user';
var CMR_MENU_VERTICAL_LINE = 'cmrpuntos-menu-vertical-line';
var CMR_PUNTOS_ICON = 'cmr-puntos-icon';
var CMR_PUNTOS_AVAILABLE = 'cmr-puntos-available';
var CMR_MENU_CATEGORY_ICON = 'cmrpuntos-menu-category-icon';
var CMR_USER_CATEGORY_NAME = 'cmr-user-category-name';
var CATEGORY_FAN$1 = 'Fan';
var CATEGORY_ELITE$1 = 'Elite';
var CATEGORY_PREMIUM$1 = 'Premium';
var TIENES_TEXT = 'Tienes';
var TIENES_CLASS = 'tienes-text';
var CMR_PUNTOS_MENU_MOBILE = 'cmr-puntos-menu-mobile';
var CMR_PUNTOS_MENU_MOBILE_REBRAND = 'cmr-puntos-menu-mobile-rebrand';
var CMR_PUNTOS_MOBILE_NAVIGATION = 'cmr-puntos-mobile-navigation';
var CMR_POINTS = 'cmr_points';
var HAS_CMR_TITLE = 'has_cmr_title';
var LOGGED_IN_TIENES_TEXT = 'logged-in-tienes-text';
var SECTION_TYPES = {
  MENU: 'menu',
  OTHERS: 'others'
};

var CmrPuntosIcon = function CmrPuntosIcon(props) {
  return React__default["default"].createElement("svg", _extends({
    width: "25",
    height: "12"
  }, props, {
    viewBox: "0 0 25 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7399 6.42868C15.9419 6.42868 16.0252 6.26299 16.0148 6.16482V5.69306V5.4192L16.0164 5.41545H14.8182V4.20557L14.8071 4.2087L14.8182 4.2012H13.7863C13.5458 4.19869 13.442 4.39784 13.4554 4.51976V5.08312V5.41545H12.5844V6.42336H13.4554V7.90085V8.36542C13.4554 9.25798 14.1532 9.60187 15.0617 9.60187C15.3821 9.60187 15.7183 9.57654 16.0164 9.47556V8.42388C15.8984 8.52548 15.6097 8.54205 15.4627 8.54205C14.9248 8.54205 14.8341 8.27694 14.8203 7.90085C14.8203 7.86459 14.8182 7.82426 14.8182 7.78737V6.42868H15.7399Z",
    fill: "#5C6166"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86117 5.39893C2.2105 5.39893 1.65595 5.76406 1.43567 6.07815H1.41673V5.50788H0V11.9998H0.789565C1.22872 11.951 1.37639 11.6585 1.41813 11.3974L1.41778 9.36991H1.43777C1.76047 9.79033 2.43043 9.94083 3.02602 9.94083C4.16179 9.94083 4.90962 9.12092 5.09868 8.12826C5.12954 7.965 5.14813 7.80271 5.14813 7.63487C5.14813 6.32517 4.23931 5.39893 2.86117 5.39893ZM2.56769 8.76691C2.03383 8.76691 1.66132 8.52054 1.50312 8.13022C1.4477 7.99444 1.41684 7.84099 1.41684 7.67282C1.41684 7.02206 1.84617 6.57611 2.56769 6.57611C3.28184 6.57611 3.71222 7.02206 3.71222 7.67282C3.71222 7.84099 3.68276 7.99444 3.62734 8.13022C3.46985 8.52054 3.09734 8.76691 2.56769 8.76691Z",
    fill: "#5C6166"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4411 5.40186C9.90263 5.40186 9.5172 5.63569 9.30422 5.89524L9.2342 5.99074C9.2342 5.99074 9.23907 5.88667 9.2342 5.85025V5.84811L9.23323 5.83097V5.81383L9.23226 5.81077L9.22902 5.78689L9.22059 5.76118L9.21508 5.73976L9.20535 5.7116L9.19271 5.68865L9.17877 5.6611L9.16321 5.63753L9.1402 5.6106L9.1175 5.5907L9.08963 5.56713L9.06564 5.54969L9.02317 5.53163L8.99594 5.52092L8.91166 5.50102H7.92555V7.49264C7.92555 7.63925 7.91518 7.7831 7.88989 7.91532C7.8202 8.25415 7.62991 8.514 7.14043 8.514C6.68303 8.514 6.53392 8.23762 6.48464 7.91532C6.46292 7.76504 6.45774 7.60711 6.45774 7.46019V5.50102H5.51539C5.39902 5.51021 5.17923 5.56132 5.14844 5.81689V7.7075C5.14844 7.77973 5.15492 7.84462 5.15492 7.91532C5.19025 8.88098 5.48168 9.6024 6.72096 9.6024C7.25713 9.6024 7.6458 9.36733 7.85975 9.10717L7.90513 9.04534L7.97483 8.92965V9.09891V9.12798V9.1341L7.97677 9.17053V9.17665L7.97936 9.18522L7.98876 9.22746L7.99071 9.23878L8.00432 9.27857L8.00724 9.2853C8.04711 9.38478 8.13658 9.48762 8.334 9.50323H8.60306H9.2342V7.91532V7.51039C9.2342 6.99098 9.33599 6.49056 10.019 6.49056C10.6929 6.49056 10.701 7.0825 10.701 7.54222V7.91532V9.50323H12.0126V7.91532V7.29736C12.0126 6.22335 11.7656 5.40186 10.4411 5.40186Z",
    fill: "#5C6166"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5905 5.39893C17.1596 5.39893 16.0166 6.22305 16.0166 7.49965C16.0166 7.6458 16.0356 7.78311 16.0628 7.91736C16.2851 8.95109 17.3227 9.59947 18.5905 9.59947C19.8551 9.59947 20.8938 8.95109 21.1151 7.91736C21.1436 7.78311 21.1647 7.6458 21.1647 7.49965C21.1647 6.22305 20.0196 5.39893 18.5905 5.39893ZM18.5905 8.51386C18.0595 8.51386 17.6843 8.28411 17.5271 7.9198C17.4736 7.79562 17.445 7.65404 17.445 7.5021C17.445 6.8998 17.8766 6.48819 18.5905 6.48819C19.3043 6.48819 19.7356 6.8998 19.7356 7.5021C19.7356 7.65404 19.7057 7.79562 19.6528 7.9198C19.4971 8.28411 19.1215 8.51386 18.5905 8.51386Z",
    fill: "#5C6166"
  }), React__default["default"].createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "21",
    y: "5",
    width: "4",
    height: "5"
  }, React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2354 5.12305H24.5191V9.80388H21.2354V5.12305Z",
    fill: "white"
  })), React__default["default"].createElement("g", {
    mask: "url(#mask0)"
  }, React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4714 7.94684C24.1797 6.7285 22.5188 7.1378 22.5188 6.5346C22.5188 6.2697 22.7559 6.16831 22.954 6.16831C23.2384 6.16831 23.4659 6.29633 23.6388 6.54382L24.3681 5.70781C24.0118 5.26847 23.4512 5.12305 22.9455 5.12305C22.137 5.12305 21.3322 5.57946 21.3322 6.62814C21.3322 7.57407 21.9515 7.80483 22.5003 7.94684C22.9397 8.05949 23.3318 8.11889 23.3318 8.43363C23.3318 8.67566 23.0623 8.7552 22.7929 8.7552C22.4387 8.7552 22.1757 8.58247 21.9556 8.26943L21.2354 9.19556C21.6151 9.64651 22.208 9.80388 22.7454 9.80388C23.5695 9.80388 24.5192 9.47275 24.5192 8.33566C24.5192 8.18716 24.5001 8.06291 24.4714 7.94684Z",
    fill: "#5C6166"
  })), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05029 3.39646C2.24758 3.39646 2.42181 3.37402 2.57365 3.32914C2.72548 3.28489 2.86711 3.23876 2.99852 3.19264C3.05583 3.16926 3.097 3.16427 3.12171 3.17799C3.14641 3.19139 3.16881 3.21975 3.18923 3.26214L3.3987 3.68163C3.42736 3.73617 3.43757 3.777 3.42933 3.80411C3.4211 3.83154 3.3987 3.8546 3.36148 3.87392C3.14015 4.00201 2.90729 4.08897 2.6629 4.13322C2.41852 4.17779 2.17742 4.20054 1.93962 4.20054C1.60301 4.20054 1.31251 4.15254 1.06846 4.05749C0.824067 3.96212 0.622826 3.82561 0.464732 3.64672C0.306967 3.46814 0.190043 3.24967 0.11396 2.9913C0.0378768 2.73325 0 2.44278 0 2.12053C0 1.80201 0.0480871 1.51248 0.14492 1.25225C0.241094 0.992011 0.375804 0.768551 0.548061 0.582491C0.720318 0.396119 0.928805 0.252132 1.17286 0.151466C1.41725 0.0501771 1.687 0 1.98277 0C2.19191 0 2.39711 0.0162063 2.59835 0.0495538C2.79926 0.082278 2.99622 0.149285 3.18923 0.250262C3.23468 0.273637 3.26103 0.297011 3.26926 0.320074C3.2775 0.343448 3.26729 0.388327 3.23863 0.454399L3.0476 0.856127C3.02718 0.910356 3.00577 0.943704 2.98304 0.955235C2.96065 0.966766 2.92047 0.963026 2.86316 0.943704C2.71527 0.893215 2.5776 0.855504 2.45046 0.83026C2.32333 0.804704 2.1817 0.792237 2.02559 0.792237C1.85761 0.792237 1.70874 0.826208 1.5793 0.89415C1.45019 0.96178 1.34117 1.05528 1.2529 1.17371C1.16463 1.29214 1.0981 1.43176 1.05297 1.5932C1.00752 1.75433 0.985126 1.9301 0.985126 2.12053C0.985126 2.31095 1.00357 2.48361 1.04079 2.63882C1.07735 2.79433 1.13696 2.92835 1.2193 3.04086C1.30132 3.15368 1.41 3.24094 1.54537 3.30296C1.68074 3.36529 1.84938 3.39646 2.05029 3.39646Z",
    fill: "#5C6166"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6651 1.78562H7.62702L7.36658 2.34311L6.83889 3.4459C6.79231 3.54977 6.74437 3.61933 6.69575 3.65556C6.64679 3.69146 6.57437 3.70941 6.47644 3.70941H6.12726C6.02118 3.70941 5.94808 3.69146 5.90796 3.65556C5.86716 3.61933 5.82194 3.54977 5.77094 3.4459L5.37721 2.66657L4.98315 1.85775H4.94506V4.08096C4.94506 4.13675 4.93418 4.17073 4.9131 4.18291C4.89168 4.19477 4.8536 4.20054 4.79852 4.20054H4.15047C4.10355 4.20054 4.06785 4.19477 4.04235 4.18291C4.01685 4.17073 4.00427 4.13675 4.00427 4.08096V0.419317C4.00427 0.267683 4.03487 0.159969 4.09641 0.095853C4.15795 0.0317373 4.26268 0 4.41092 0H4.77948C4.89814 0 4.98621 0.0208376 5.04333 0.0628334C5.10079 0.104829 5.15451 0.177601 5.20551 0.281789L5.8981 1.74363L6.29216 2.59444H6.31766L6.74981 1.65996L7.3982 0.29365C7.4492 0.185936 7.5053 0.109638 7.5665 0.0660392C7.62804 0.0217993 7.72664 0 7.8623 0H8.17375C8.30941 0 8.41073 0.0269286 8.47873 0.0807858C8.54639 0.134964 8.58039 0.237549 8.58039 0.389503V4.08096C8.58039 4.13675 8.56985 4.17073 8.54843 4.18291C8.52735 4.19477 8.48893 4.20054 8.43419 4.20054H7.80484C7.75826 4.20054 7.72324 4.19477 7.70012 4.18291C7.67666 4.17073 7.6651 4.13675 7.6651 4.08096V1.78562Z",
    fill: "#5C6166"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.42 1.279C11.42 1.22707 11.4132 1.17321 11.3988 1.11743C11.3845 1.06133 11.3571 1.01036 11.3168 0.964513C11.2761 0.91867 11.2214 0.880521 11.1523 0.850387C11.0833 0.820573 10.9961 0.805506 10.8906 0.805506H10.0629V1.76468H10.8723C11.0508 1.76468 11.1869 1.71948 11.28 1.62971C11.3734 1.53963 11.42 1.42294 11.42 1.279ZM11.8101 2.23507C11.9478 2.29502 12.0452 2.37997 12.1021 2.48993C12.1591 2.59989 12.2057 2.7246 12.2421 2.86437L12.5528 4.06269C12.5606 4.08706 12.5596 4.11559 12.5495 4.14989C12.5394 4.18355 12.5098 4.20054 12.4613 4.20054H11.8221C11.7775 4.20054 11.731 4.19573 11.6821 4.18547C11.6333 4.17586 11.5991 4.14091 11.5786 4.08096L11.3109 3.02017C11.2579 2.82462 11.18 2.68869 11.0765 2.61272C10.973 2.53706 10.83 2.49891 10.6474 2.49891H10.0571V4.07455C10.0571 4.13065 10.0489 4.16592 10.033 4.1797C10.0164 4.19381 9.97794 4.20054 9.91706 4.20054H9.26586C9.21702 4.20054 9.18153 4.19188 9.15939 4.17361C9.13692 4.15566 9.12585 4.12296 9.12585 4.07455V0.36546C9.12585 0.245563 9.15027 0.154839 9.19879 0.0929678C9.24763 0.0307755 9.34498 0 9.49117 0H10.9821C11.4246 0 11.7661 0.109638 12.0077 0.329555C12.249 0.54883 12.3701 0.844724 12.3701 1.21627C12.3701 1.42016 12.3213 1.61187 12.2239 1.79171C12.1266 1.97156 11.9865 2.10941 11.8039 2.20494L11.8101 2.23507Z",
    fill: "#5C6166"
  }));
};
var CmrPuntosIcon$1 = CmrPuntosIcon;

var isMenuSection = function isMenuSection(section) {
  return section === SECTION_TYPES.MENU;
};
var Image = function Image(_ref) {
  var src = _ref.src;
  return React__default["default"].createElement("img", {
    src: src,
    alt: CMR_PUNTOS_ALT_LOGO_TEXT
  });
};
var CmrPuntosMenuMobile = function CmrPuntosMenuMobile(_ref2) {
  var cmrPuntosURL = _ref2.cmrPuntosURL,
    cmrpuntosImageUrl = _ref2.cmrpuntosImageUrl,
    cmrText = _ref2.cmrText,
    imageStyle = _ref2.imageStyle,
    isCmrPointsEnabled = _ref2.isCmrPointsEnabled,
    isLoggedIn = _ref2.isLoggedIn,
    isRebrandingEnabled = _ref2.isRebrandingEnabled,
    isNewTab = _ref2.isNewTab,
    tenantId = _ref2.tenantId,
    isNavigationMobileMenu = _ref2.isNavigationMobileMenu,
    section = _ref2.section,
    cmrPoints = _ref2.cmrPoints;
  var useCmrPoints = hooks$1.useCmrPoints;
  var _useCmrPoints = useCmrPoints(tenantId, isCmrPointsEnabled, isLoggedIn, cmrPoints),
    balancePoints = _useCmrPoints.balancePoints;
    _useCmrPoints.loggedIn;
    var cmrCategory = _useCmrPoints.cmrCategory;
  var _ref3 = cmrCategory ? getCategoryStyle(cmrCategory, isRebrandingEnabled) : {},
    categoryClassName = _ref3.categoryClassName,
    categoryIcon = _ref3.categoryIcon;
  if (!isRebrandingEnabled) {
    return React__default["default"].createElement("a", {
      className: styles$1[CMR_PUNTOS_MENU_MOBILE],
      href: cmrPuntosURL,
      target: isNewTab ? '_blank' : '',
      rel: "noreferrer",
      id: "testId-cmr-points"
    }, React__default["default"].createElement("div", null, isLoggedIn && balancePoints >= 0 ? React__default["default"].createElement("div", {
      className: styles$1[CMR_MENU_LOGGED_IN_USER]
    }, cmrCategory === CATEGORY_FAN$1 || cmrCategory === CATEGORY_ELITE$1 || cmrCategory === CATEGORY_PREMIUM$1 ? React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement("span", {
      className: styles$1[CMR_MENU_CATEGORY_ICON]
    }, categoryIcon), React__default["default"].createElement("span", {
      className: "".concat(styles$1[CMR_USER_CATEGORY_NAME], " ").concat(styles$1[categoryClassName])
    }, cmrCategory), React__default["default"].createElement("span", {
      className: styles$1[CMR_MENU_VERTICAL_LINE]
    })) : React__default["default"].createElement("span", {
      className: styles$1[TIENES_CLASS]
    }, TIENES_TEXT), React__default["default"].createElement("span", {
      className: styles$1[CMR_PUNTOS_AVAILABLE]
    }, formatPonits(balancePoints, tenantId)), React__default["default"].createElement("span", {
      className: styles$1[CMR_PUNTOS_ICON]
    }, React__default["default"].createElement(CmrPuntosIcon$1, null))) : cmrText), React__default["default"].createElement("span", {
      className: styles$1[imageStyle]
    }, React__default["default"].createElement(Image, {
      src: cmrpuntosImageUrl
    })));
  }
  var isNavigationMenu = isNavigationMobileMenu ? styles$1[CMR_PUNTOS_MOBILE_NAVIGATION] : '';
  var hasCMRTitle = cmrText && cmrText.split('|') && cmrText.split('|')[0];
  var noCMRTitle = cmrText && cmrText.split('|') && cmrText.split('|')[1];
  if (isMenuSection(section)) {
    return React__default["default"].createElement("a", {
      className: "".concat(styles$1[CMR_PUNTOS_MENU_MOBILE], " ").concat(styles$1[CMR_PUNTOS_MENU_MOBILE_REBRAND], " ").concat(isNavigationMenu),
      href: cmrPuntosURL,
      target: isNewTab ? '_blank' : '',
      rel: "noreferrer"
    }, isLoggedIn && balancePoints >= 0 ? React__default["default"].createElement(React__default["default"].Fragment, null, ![CATEGORY_PREMIUM$1, CATEGORY_FAN$1, CATEGORY_ELITE$1].includes(cmrCategory) ? React__default["default"].createElement("span", {
      className: styles$1[HAS_CMR_TITLE]
    }, hasCMRTitle) : '', React__default["default"].createElement("span", {
      className: styles$1[CMR_PUNTOS_AVAILABLE]
    }, formatPonits(balancePoints)), React__default["default"].createElement("span", {
      className: styles$1[CMR_POINTS]
    }, React__default["default"].createElement(CmrPointsIcon$1, {
      isRebrandingEnabled: isRebrandingEnabled
    })), [CATEGORY_PREMIUM$1, CATEGORY_FAN$1, CATEGORY_ELITE$1].includes(cmrCategory) ? React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement("span", {
      className: styles$1[CMR_MENU_VERTICAL_LINE]
    }), React__default["default"].createElement("span", {
      className: styles$1[CMR_MENU_CATEGORY_ICON]
    }, categoryIcon), React__default["default"].createElement("span", {
      className: "".concat(styles$1[CMR_USER_CATEGORY_NAME], " ").concat(styles$1[categoryClassName])
    }, cmrCategory)) : React__default["default"].createElement(React__default["default"].Fragment, null)) : React__default["default"].createElement("span", {
      className: styles$1[TIENES_CLASS]
    }, noCMRTitle));
  }
  return React__default["default"].createElement("a", {
    className: "".concat(styles$1[CMR_PUNTOS_MENU_MOBILE], " ").concat(styles$1[CMR_PUNTOS_MENU_MOBILE_REBRAND], " ").concat(isNavigationMenu),
    href: cmrPuntosURL,
    target: isNewTab ? '_blank' : '',
    rel: "noreferrer"
  }, isLoggedIn && balancePoints >= 0 ? React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement("span", {
    className: styles$1[LOGGED_IN_TIENES_TEXT]
  }, hasCMRTitle), React__default["default"].createElement("span", {
    className: styles$1[CMR_PUNTOS_AVAILABLE]
  }, formatPonits(balancePoints)), React__default["default"].createElement("span", {
    className: styles$1[CMR_POINTS]
  }, React__default["default"].createElement(CmrPointsIcon$1, {
    isRebrandingEnabled: isRebrandingEnabled
  })), [CATEGORY_PREMIUM$1, CATEGORY_FAN$1, CATEGORY_ELITE$1].includes(cmrCategory) ? React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement("span", {
    className: styles$1[CMR_MENU_VERTICAL_LINE]
  }), !isNavigationMobileMenu && React__default["default"].createElement("span", {
    className: styles$1[CMR_MENU_CATEGORY_ICON]
  }, categoryIcon), React__default["default"].createElement("span", {
    className: "".concat(styles$1[CMR_USER_CATEGORY_NAME], " ").concat(styles$1[categoryClassName])
  }, cmrCategory)) : React__default["default"].createElement(React__default["default"].Fragment, null)) : React__default["default"].createElement("span", {
    className: styles$1[TIENES_CLASS]
  }, noCMRTitle));
};
CmrPuntosMenuMobile.propTypes = process.env.NODE_ENV !== "production" ? {
  cmrPuntosURL: PropTypes__default["default"].string.isRequired,
  cmrpuntosImageUrl: PropTypes__default["default"].string.isRequired,
  cmrText: PropTypes__default["default"].string,
  isRebrandingEnabled: PropTypes__default["default"].bool,
  isCmrPointsEnabled: PropTypes__default["default"].bool,
  isLoggedIn: PropTypes__default["default"].bool,
  isNewTab: PropTypes__default["default"].bool,
  tenantId: PropTypes__default["default"].string.isRequired,
  isNavigationMobileMenu: PropTypes__default["default"].bool,
  sections: PropTypes__default["default"].string,
  cmrPoints: PropTypes__default["default"].object
} : {};
CmrPuntosMenuMobile.defaultProps = {
  isRebrandingEnabled: false,
  isCmrPointsEnabled: false,
  isNewTab: false,
  isLoggedIn: false,
  isNavigationMobileMenu: false,
  section: 'others'
};
var CmrPuntosMenuMobile$1 = CmrPuntosMenuMobile;

var css_248z = ".CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m {\n  list-style-type: none;\n  margin-bottom: 1.25rem;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a {\n  text-decoration: none;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM {\n  display: flex;\n  align-items: center;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_cmr-text__1HkFp {\n  color: #8A9199;\n  letter-spacing: 0.6px;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_cmr-puntos-vertical-line__VrNcy {\n  width: 0px;\n  height: 17px;\n  margin: 0 0 0 7px;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_cmr-category-icon__jTkx8 {\n  margin: 0 5px 0 10px;\n  height: 15px;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_cmr-category-icon__jTkx8 img {\n  width: 15px;\n  height: 15px;\n  vertical-align: middle;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_category-fan__wvv7Y {\n  color: #EB0045;\n  font-size: 12px;\n  letter-spacing: 0.675px;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_category-premium__K572q {\n  color: #808080;\n  font-size: 12px;\n  letter-spacing: 0.675px;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_category-elite__QAKwr {\n  color: #000000;\n  font-size: 12px;\n  letter-spacing: 0.675px;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_category-fan-vertical-line__Ly05R {\n  border-left: 1px solid #EB0045;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_category-premium-vertical-line__r2Vmr {\n  border-left: 1px solid #808080;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_category-elite-vertical-line__C3OI4 {\n  border-left: 1px solid #000000;\n}\n.CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m a:hover {\n  text-decoration: none;\n}\n\n.CmrPuntosCategoryItem_cmr-puntos-rebranding__bcl1H a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM {\n  height: 17px;\n  line-height: 0;\n}\n.CmrPuntosCategoryItem_cmr-puntos-rebranding__bcl1H a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_cmr-text__1HkFp {\n  color: #495867;\n  letter-spacing: 0;\n}\n.CmrPuntosCategoryItem_cmr-puntos-rebranding__bcl1H a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_cmr-text__1HkFp:hover {\n  color: #0C2941;\n}\n.CmrPuntosCategoryItem_cmr-puntos-rebranding__bcl1H a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_cmr-category-icon__jTkx8 {\n  height: auto;\n  margin: 0 5px 0 8px;\n}\n.CmrPuntosCategoryItem_cmr-puntos-rebranding__bcl1H a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_category-fan__wvv7Y {\n  font-size: 14px;\n}\n.CmrPuntosCategoryItem_cmr-puntos-rebranding__bcl1H a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_rebranding-line__GXp5- {\n  height: 13px;\n  border-left: 1px solid #495867;\n  margin: 0 0 0 4px;\n}\n.CmrPuntosCategoryItem_cmr-puntos-rebranding__bcl1H a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_line-hover__E6xgV {\n  border-left: 1px solid #0C2941;\n}\n.CmrPuntosCategoryItem_cmr-puntos-rebranding__bcl1H a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_category-premium__K572q {\n  font-size: 14px;\n}\n.CmrPuntosCategoryItem_cmr-puntos-rebranding__bcl1H a .CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM .CmrPuntosCategoryItem_category-elite__QAKwr {\n  font-size: 14px;\n}";
var styles = {"cmr-puntos-category-item":"CmrPuntosCategoryItem_cmr-puntos-category-item__CuZ3m","cmr-puntos-category-container":"CmrPuntosCategoryItem_cmr-puntos-category-container__sOvWM","cmr-text":"CmrPuntosCategoryItem_cmr-text__1HkFp","cmr-puntos-vertical-line":"CmrPuntosCategoryItem_cmr-puntos-vertical-line__VrNcy","cmr-category-icon":"CmrPuntosCategoryItem_cmr-category-icon__jTkx8","category-fan":"CmrPuntosCategoryItem_category-fan__wvv7Y","category-premium":"CmrPuntosCategoryItem_category-premium__K572q","category-elite":"CmrPuntosCategoryItem_category-elite__QAKwr","category-fan-vertical-line":"CmrPuntosCategoryItem_category-fan-vertical-line__Ly05R","category-premium-vertical-line":"CmrPuntosCategoryItem_category-premium-vertical-line__r2Vmr","category-elite-vertical-line":"CmrPuntosCategoryItem_category-elite-vertical-line__C3OI4","cmr-puntos-rebranding":"CmrPuntosCategoryItem_cmr-puntos-rebranding__bcl1H","rebranding-line":"CmrPuntosCategoryItem_rebranding-line__GXp5-","line-hover":"CmrPuntosCategoryItem_line-hover__E6xgV"};
styleInject(css_248z);

var CMR_PUNTOS_CATEGORY_CONTAINER = 'cmr-puntos-category-container';
var CMR_TEXT = 'cmr-text';
var CMR_PUNTOS_VERTICAL_LINE = 'cmr-puntos-vertical-line';
var CMR_CATEGORY_ICON = 'cmr-category-icon';
var CATEGORY_FAN = 'Fan';
var CATEGORY_ELITE = 'Elite';
var CATEGORY_PREMIUM = 'Premium';
var CMR_PUNTOS_CATEGORY_ITEM = 'cmr-puntos-category-item';
var CMR_PUNTOS_REBRANDING = 'cmr-puntos-rebranding';
var REBRANDING_LINE = 'rebranding-line';
var REBRANDING_LINE_HOVER = 'line-hover';

var CmrPuntosCategoryItem = function CmrPuntosCategoryItem(_ref) {
  var cmrPuntosURL = _ref.cmrPuntosURL,
    cmrText = _ref.cmrText,
    isCmrPointsEnabled = _ref.isCmrPointsEnabled,
    isRebrandingEnabled = _ref.isRebrandingEnabled,
    isLoggedIn = _ref.isLoggedIn,
    isNewTab = _ref.isNewTab,
    tenantId = _ref.tenantId,
    cmrPoints = _ref.cmrPoints;
  var useCmrPoints = hooks$1.useCmrPoints;
  var _useCmrPoints = useCmrPoints(tenantId, isCmrPointsEnabled, isLoggedIn, cmrPoints),
    cmrCategory = _useCmrPoints.cmrCategory;
  var _React$useState = React__default["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    onHover = _React$useState2[0],
    setOnHover = _React$useState2[1];
  var _ref2 = cmrCategory ? getCategoryStyle(cmrCategory, isRebrandingEnabled) : {},
    categoryClassName = _ref2.categoryClassName,
    categoryIcon = _ref2.categoryIcon,
    verticalLineColor = _ref2.verticalLineColor;
  return React__default["default"].createElement("li", {
    className: "".concat(styles[CMR_PUNTOS_CATEGORY_ITEM], " ").concat(isRebrandingEnabled ? styles[CMR_PUNTOS_REBRANDING] : ''),
    onMouseEnter: function onMouseEnter() {
      return setOnHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setOnHover(false);
    }
  }, React__default["default"].createElement("a", {
    id: "testId-cmr-points",
    href: cmrPuntosURL,
    target: isNewTab ? '_blank' : '',
    rel: "noreferrer"
  }, React__default["default"].createElement("div", {
    className: styles[CMR_PUNTOS_CATEGORY_CONTAINER]
  }, React__default["default"].createElement("span", {
    className: styles[CMR_TEXT]
  }, cmrText), cmrCategory && (cmrCategory === CATEGORY_FAN || cmrCategory === CATEGORY_ELITE || cmrCategory === CATEGORY_PREMIUM) ? React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement("span", {
    className: "".concat(styles[CMR_PUNTOS_VERTICAL_LINE], " ").concat(styles[verticalLineColor], " ").concat(isRebrandingEnabled && styles[REBRANDING_LINE], "\n                ").concat(onHover ? styles[REBRANDING_LINE_HOVER] : '')
  }), React__default["default"].createElement("span", {
    className: styles[CMR_CATEGORY_ICON]
  }, categoryIcon), React__default["default"].createElement("span", {
    className: styles[categoryClassName]
  }, cmrCategory)) : '')));
};
CmrPuntosCategoryItem.propTypes = process.env.NODE_ENV !== "production" ? {
  cmrPuntosURL: PropTypes__default["default"].string.isRequired,
  cmrText: PropTypes__default["default"].string,
  isRebrandingEnabled: PropTypes__default["default"].bool,
  isCmrPointsEnabled: PropTypes__default["default"].bool,
  isNewTab: PropTypes__default["default"].bool,
  isLoggedIn: PropTypes__default["default"].bool,
  tenantId: PropTypes__default["default"].string,
  cmrPoints: PropTypes__default["default"].object
} : {};
CmrPuntosCategoryItem.defaultProps = {
  isRebrandingEnabled: false,
  isLoggedIn: false,
  isCmrPointsEnabled: false,
  isNewTab: false,
  tenantId: ''
};
var CmrPuntosCategoryItem$1 = CmrPuntosCategoryItem;

var useCmrPoints = hooks$1.useCmrPoints;
var index = {
  CmrPuntosMenuMobile: CmrPuntosMenuMobile$1,
  CmrPuntosCategoryItem: CmrPuntosCategoryItem$1,
  useCmrPoints: useCmrPoints
};

module.exports = index;
